import { DiagramScreenshot, TelegramNotifications } from '../../screenshots'
import React from 'react'
import SectionCard from './SectioncCard'
import cn from 'classnames'
import { Table } from '../../components/Table'

const MonitoringPossibilitiesTable = () => {
  const tableData = [
    {
      name: 'Мониторинг цен на макретплейсах.',
      desc: 'Проверяем цены на маркетплейсах. Можно настроить периодичность обновления данных. Например каждый час или раз в сутки'
    },
    {
      name: 'Учет скидок и карт',
      desc: 'Сохраняем все типы цен, включая СПП, карты маркетплейсов, wb кошелек и кешбек'
    },
    {
      name: 'Уведомления',
      desc: 'Отправляем оповещения о снижении цен, нарушении РРЦ, изменении наличия. Можно выбрать каналы (Telegram, email) и настроить расписание'
    },
    {
      name: 'Акции',
      desc: 'Показываем в каких акциях участвуют конкуренты'
    },
    {
      name: 'Контроль РРЦ',
      desc: 'Отслеживаем товары с нарушением РРЦ. При необходимости присылаем уведомления'
    },
    {
      name: 'Сравнение с вашей ценой',
      desc: 'Подсвечиваем, если цена конкурента ниже вашей'
    },
    {
      name: 'История изменений',
      desc: 'Храним историю цен за любой период. Можно отследить, как менялись цены у конкурентов'
    },
    {
      name: 'Аналитика и сравнение',
      desc: 'Строим графики и таблицы с динамикой цен по дням и часам. Можно вывести всех конкурентов на единый график для наглядного сравнения'
    },
    {
      name: 'Экспорт данных',
      desc: 'Все данные экспортируются в Excel'
    },
    {
      name: 'Массовое добавление товаров',
      desc: 'Возможность загрузки и редактирования товаров через Excel-файл'
    },
    {
      name: 'Рекомендации конкурентов',
      desc: 'После добавления ваших товаров находим соответствующих конкурентов на маркетплейсах'
    },
    {
      name: 'Фильтрация',
      desc: 'Поддерживается гибкая фильтрация по: маркетплейсу, продавцу, бренду, категории, типу цены (включая карту Ozon, WB-кошелёк и без карты), участию в акциях, нарушению РРЦ, а также по конкурентам, чья цена ниже вашей на заданный процент'
    }
  ]

  const cols = {
    name: {
      renderCell: (value, i) => (
        <div className="sm:w-[280px] text-sm lg:text-[20px] font-medium">
          <div
            className={cn('text-xs text-[#919BA0] mb-2 font-normal', {
              'lg:hidden': i !== 0,
              'lg:mb-8 lg:text-[16px]': i === 0
            })}
          >
            Название
          </div>
          {value}
        </div>
      )
    },
    desc: {
      renderCell: (value, i) => (
        <div className="sm:w-[450px] leading-[22px]">
          <div
            className={cn('text-xs text-[#919BA0] mb-2 font-normal', {
              'lg:hidden': i !== 0,
              'lg:mb-8 lg:text-[16px]': i === 0
            })}
          >
            Описание
          </div>
          {value}
        </div>
      )
    }
  }

  return (
    <Table
      buttonText="Все возможности мониторинга"
      title="Возможности мониторинга"
      tableData={tableData}
      cols={cols}
      Table
    />
  )
}

const MonitoringSection = () => {
  return (
    <div className="max-w-[1200px] mx-auto mb-20">
      <h1 className="text-[#FBFBFC] text-4xl md:text-[60px] font-medium leading-tight mb-12 text-center">
        <span className="text-[#52575D]"> Мониторинг цен —</span>
        <br className="hidden lg:block" /> полный контроль за конкурентами
        <br className="hidden lg:block" /> на маркетплейсах
      </h1>
      <div className="grid grid-cols-1 gap-6 mb-8 lg:text-center overflow-hidden">
        <div className="lg:flex space-x-5 self-center">
          <div className="grid lg:grid-cols-2 gap-6 ">
            <SectionCard size="lg" className=" items-center  overflow-hidden">
              <div className="absolute inset-0 rounded-full  blur-[80px] z-0 h-[90%] opacity-20 -translate-y-2/3 bg-[#962b92]"></div>
              <span className="block text-2xl leading-[34px] text-white font-medium">
                <div className="flex flex-row lg:block justify-between gap-6">
                  <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
                    {' '}
                    Учитываем особенности
                    <br className="hidden lg:block" /> маркетплейсов
                  </h3>
                  <span className="block lg:hidden">
                    <img
                      src="/assets/marketplace-graph.png"
                      alt="Padlock icon"
                    />
                  </span>
                </div>
              </span>
              <span className="block mt-10 lg:mb-20 text-lg text-[#919BA0] font-normal">
                Сохраняем все типы цен, включая карты маркетплейсов, wb кошелек
                и кешбек
              </span>
              <div className=" hidden lg:block ">
                <DiagramScreenshot />
              </div>
            </SectionCard>

            <div className="flex flex-col space-y-5">
              <SectionCard size="sm" className="hidden lg:block">
                <div className="grid grid-cols-3 gap-8 items-start">
                  <div className="col-span-2">
                    <span className="block  text-xl leading-[27px] text-white text-left font-medium">
                      <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
                        {' '}
                        Уведомляем в Telegram <br className="hidden lg:block" />{' '}
                        или на почту
                      </h3>
                    </span>
                    <span className="block mt-5 text-left text-base text-[#919BA0] font-normal">
                      Присылаем уведомления об изменении цен и наличия по вашему
                      графику
                    </span>
                  </div>
                  <div className="relative">
                    <TelegramNotifications />
                  </div>
                </div>
              </SectionCard>
              <SectionCard size="sm" className="block lg:hidden">
                <div className={'text-left'}>
                  <span className="block text-xl leading-[34px] text-white  font-medium">
                    <div className="flex flex-row lg:block justify-between gap-6">
                      <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
                        {' '}
                        Уведомляем в Telegram <br className="hidden lg:block" />{' '}
                        или на почту
                      </h3>
                      <span className="block lg:hidden">
                        <img
                          src="/assets/tg_notif.png"
                          alt="Telegram icon"
                          width={130}
                        />
                      </span>
                    </div>
                  </span>
                  <span className="block mt-5 text-base text-[#919BA0] font-normal">
                    Присылаем уведомления об изменении цен и наличия по вашему
                    графику{' '}
                  </span>
                </div>
              </SectionCard>

              <SectionCard size="sm">
                <div className={'text-left'}>
                  <span className="block text-xl leading-[34px] text-white  font-medium">
                    <div className="flex flex-row lg:block justify-between gap-6">
                      <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
                        {' '}
                        Покажем, сколько вы зарабатываете
                        <br className="hidden lg:block" />с каждой продажи
                      </h3>
                      <span className="block lg:hidden">
                        <img src="/assets/income.png" alt="Padlock icon" />
                      </span>
                    </div>
                  </span>
                  <span className="block mt-5 text-base text-[#919BA0] font-normal">
                    Рассчитываем юнит экономику и маржу.
                    <br className="hidden lg:block" />
                    Учитываем комиссии, логистику, рекламу и прочие расходы.
                    Показываем допустимую скидку — чтобы вы не ушли в минус
                  </span>
                </div>
              </SectionCard>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 text-left overflow-hidden">
          <SectionCard size="xs" className={'overflow-hidden lg:pb-52'}>
            <span className="block text-xl leading-[34px] text-white  font-medium">
              <div className="flex flex-row lg:block justify-between gap-6">
                <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
                  {' '}
                  Анализируем акции
                </h3>
                <span className="block lg:hidden">
                  <img
                    src="/assets/analyse.png"
                    alt="Padlock icon"
                    width={60}
                  />
                </span>
              </div>
            </span>
            <span className="block mt-1  text-base text-[#919BA0] font-normal">
              Показываем, в каких акциях участвуют конкуренты
            </span>
            <div className=" hidden lg:block absolute bottom-0 right-0">
              <img
                src="/assets/percent.png"
                alt="Percent icon"
                width={220}
                height={240}
              />
              <div className="absolute bottom-0 left-0 transform   w-[90%] h-48 bg-gradient-to-t from-yellow-400/90 via-yellow-500/50 to-transparent blur-[50px] rounded-full"></div>
            </div>
          </SectionCard>

          <SectionCard size="xs" className="lg:pt-0 flex flex-col items-end  ">
            <div className="relative hidden lg:block">
              <img
                src="/assets/rrc.png"
                alt="RRC file icon"
                width={200}
                height={200}
              />
              <div className="absolute -top-[70px] left-0 transform  w-[90%] h-48 bg-gradient-to-t from-yellow-400/90 via-yellow-500/50 to-transparent blur-[50px] rounded-full"></div>
            </div>
            <div className="lg:flex lg:flex-col items-start">
              <span className="block text-xl leading-[34px] text-white  font-medium">
                <div className="flex flex-row lg:block justify-between gap-6">
                  <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
                    Контроль
                    <br className="block lg:hidden" /> РРЦ
                  </h3>
                  <span className="block lg:hidden">
                    <img
                      src="/assets/rrc-small.png"
                      alt="Padlock icon"
                      width={60}
                    />
                  </span>
                </div>
              </span>
              <span className="block mt-1  text-base text-[#919BA0] font-normal">
                Покажем нарушение РРЦ и отправим уведомления
              </span>
            </div>
          </SectionCard>

          <SectionCard
            size="xs"
            className="text-left flex-grow justify-between relative overflow-hidden lg:pb-52"
          >
            <div className={'lg:flex lg:flex-col items-start'}>
              <span className="block text-xl leading-[34px] text-white  font-medium">
                <div className="flex flex-row lg:block justify-between gap-6">
                  <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
                    Экспорт
                    <br className="block lg:hidden" /> отчетов
                  </h3>
                  <span className="block lg:hidden">
                    <img
                      src="/assets/excel-small.png"
                      alt="Export icon"
                      width={60}
                    />
                  </span>
                </div>
              </span>
              <span className="block   mt-1 text-base text-[#919BA0] font-normal">
                Сохраняйте данные в Excel
              </span>
            </div>
            <div className="hidden lg:block absolute bottom-0 right-0">
              <img
                src="/assets/excel.png"
                alt="Excel file icon"
                width={220}
                height={240}
              />
              <div className="absolute bottom-0 left-0 transform  w-[90%] h-48 bg-gradient-to-t from-green-400/90 via-green-500/50 to-transparent blur-[50px] rounded-full"></div>
            </div>
          </SectionCard>
        </div>
      </div>
      <MonitoringPossibilitiesTable />
    </div>
  )
}

export default MonitoringSection
